import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { ITempUploadSchema } from '../../type/tempUpload';

export interface IUploadTempFileMutationFields {
  files: FileList | File[];
}


export interface IUploadTempFileMutationResponseFields {
  tempUploads?: ITempUploadSchema[];
}



export function uploadTempFileMutation(fragment: string): DocumentNode {
  return gql`
        mutation uploadTempFile (
        $files: [Upload]!
        ) {
        uploadTempFile (
        files: $files
        ) {
        ...fragment
        }
        }
        fragment fragment on UploadTempFileMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUploadTempFileMutation<TData extends Partial<IUploadTempFileMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ uploadTempFile: TData },
        IUploadTempFileMutationFields>,
) {
  return useMutation<{ uploadTempFile: TData },
      IUploadTempFileMutationFields>(
        uploadTempFileMutation(fragment), options,
      );
}
